export default __webpack_public_path__ + "static/media/rewards_icon_foodDrinks.305205a0.svg";